import { type RefObject, useEffect } from 'react';
import { syncStackedBarChartHorizontalGridLines } from './syncStackedBarChartHorizontalGridLines';

type UseSyncStackedBarChartHorizontalGridLinesProps = {
  containerRef: RefObject<HTMLDivElement | null>;
  showHorizontalGrid: boolean;
};

export const useSyncStackedBarChartHorizontalGridLines = ({
  containerRef,
  showHorizontalGrid,
}: UseSyncStackedBarChartHorizontalGridLinesProps): void => {
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const syncHorizontalGridLines = (): void => {
      syncStackedBarChartHorizontalGridLines(container, showHorizontalGrid);
    };

    const frameId = requestAnimationFrame(syncHorizontalGridLines);
    window.addEventListener('resize', syncHorizontalGridLines);
    return () => {
      cancelAnimationFrame(frameId);
      window.removeEventListener('resize', syncHorizontalGridLines);
    };
  });
};
